export default __webpack_public_path__ + "static/media/polk_inventory_ssrank.8b1430ff.png";